import uuid from 'lodash/uniqueId';
import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
  types,
  getRoot,
  destroy,
  getParent,
  detach,
  clone,
} from 'mobx-state-tree';

import createStore from 'widgets/lib/create-store';
import { debug, storage, utils } from 'lib';
import { getTimerText } from 'lib/utils';

const log = debug.create('oath');

const maxLength = 100;
const textList = [
  // '良辰美景映红烛，缘定三生心相印',
  // '祝你们幸福美满',
  // '模仿大象鼻子原地转10圈',
  // '做20个深蹲',
  // '做10个仰卧起坐',
  // '含水说一段绕口令',
  // '画一个鬼脸',
  // '对胜方用户表白',
  // '干一杯醋',
  // '摆10个性感魅惑的pose',
  // '持续大笑60秒',
  // '单脚独立保持30秒',
  // '放置一样物品在额头保持不掉落转圈1分钟',
  // '使用方言向对方认输1分钟',
  // '说出胜方的10个优点',
  // '钻进被套里跳舞60秒',
  // '给自己扎两个冲天辫',
];

const ItemModel = types
  .model('ItemModel', {
    key: '',
    left: 960,
    width: 0,
    colorStyle: 0, // red,blue,yellow  随机颜色风格
    text: '',
  })
  .actions((self) => {
    const setWidth = (width) => {
      self.width = width;
    };

    const move = () => {
      self.left--;
      if (self.width && self.left + self.width < 0) {
        destroy(self);
      }
    };

    const remove = () => {
      destroy(self);
    };
    return {
      setWidth,
      remove,
      move,
    };
  });

const RowModel = types
  .model('RowModel', {
    bottom: 10,
    width: 960,
    items: types.array(ItemModel),
  })
  .views((self) => {
    return {
      get isEnableAppend() {
        const len = self.items.length;
        if (!len) {
          return true;
        }
        const last = self.items[len - 1];

        return last.width > 0 && self.width - last.width - last.left > 100;
      },
    };
  });

const EffectModel = types.model('EffectModel', {
  round: 0,
  timestamp: 0,
});

const OathModel = types
  .model('OathModel', {
    rows: types.array(RowModel),
    effect: types.maybeNull(EffectModel),
  })
  .views((self) => {
    return {
      get isMoving() {
        return self.rows.some((row) => {
          return row.items.length > 0;
        });
      },
    };
  })
  .actions((self) => {
    const nextItem = () => {
      if (textList.length === 0) {
        return;
      }

      self.rows.some((row) => {
        if (row.isEnableAppend) {
          const first = textList.shift();
          if (first) {
            const itemModel = ItemModel.create({
              key: utils.getRandomString(),
              colorStyle: utils.getRangeNum(0, 3),
              text: first,
            });
            row.items.push(itemModel);
            return true;
          }
        }
        return false;
      });
    };

    const moveRows = () => {
      nextItem();

      return self.rows.forEach((row) => {
        row.items.forEach((item) => {
          // console.log('move', item.uid, item.left);
          item.move();
          // if (item.left + item.width < 0) {
          //   destroy(item);
          // }
        });
      });
    };

    const pushItem = (text) => {
      if (textList.length > maxLength) {
        textList.shift();
      }

      textList.push(text);
      nextItem();
    };

    const setEffect = (data) => {
      self.effect = data;
    };

    return {
      moveRows,
      pushItem,
      setEffect,
    };
  });

const initState = {
  rows: [
    {
      width: 960,
      bottom: 10,
      left: 0,
      items: [],
    },
    {
      width: 960,
      bottom: 47,
      left: 0,
      items: [],
    },
    {
      width: 960,
      bottom: 84,
      left: 0,
      items: [],
    },
  ],
};

const { store, Provider, useStore, withStore } = createStore(
  OathModel,
  initState,
);

export {
  store as oathStore,
  Provider,
  useStore as useOathStore,
  withStore as withOathStore,
};
